<div class="
    space-y-6
    pb-20
    max-w-6xl mx-auto

    bg-green-500/0
    ">

    <div class="
        bg-green-500/0
        text-3xl text-gray-50/50
        font-semibold text-center
        ">
        <h1 class="cent">
            {{ 'pages.games.title' | translate }}
        </h1>
    </div>

    <ng-container *ngIf="game">
        <section class="grid gap-6 grid-cols-1 lg:grid-cols-3">

            <div class="space-y-2 lg:col-span-3">

                <div class="
                    px-0 lg:px-48
                    space-y-2
                    ">

                    <div class="bg-green-500/0">

                        <p class="
                            text-sm uppercase tracking-wide
                            text-gray-400 flex items-center gap-2
                            pl-3
                            ">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-5 h-5 text-gray-400">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3.75 6h16.5M3.75 12h16.5M3.75 18h16.5" />
                            </svg>
                            {{ 'ui.selectGame' | translate }}
                        </p>

                        <select id="gameSelect" [(ngModel)]="selectedGameId" (ngModelChange)="onGameChange($event)"
                            class="
                                px-3 py-2

                                bg-zinc-800/0

                                text-2xl lg:text-3xl
                                font-semibold text-gray-50

                                rounded-lg
                                border border-zinc-700/0
                                focus:outline-none
                                ">
                            <option *ngFor="let g of games" [value]="g.id">{{ 'game.' + g.transKey + '.title' |
                                translate }}
                            </option>

                        </select>
                    </div>

                    <img *ngIf="game.BannerImgUrl" [src]="game.BannerImgUrl" class="w-full">

                    <div class="
                        rounded-xl
                        px-4 py-2

                        bg-zinc-900/0

                        shadow-md shadow-black/0
                        border border-zinc-800/0

                        text-gray-400
                        ">

                        <h3 class="
                            ml-0.5
                            font-semibold text-gray-50
                            ">
                            {{ 'pages.games.Summary' | translate}}
                        </h3>

                        @if (game.summary)
                        {
                        <p>
                            {{ game.summary }}
                        </p>
                        }
                        @else {
                        <p>
                            {{ 'game.' + game.transKey + '.description' | translate }}
                        </p>
                        }

                        <!-- TODO: REVIEW THIS! (iahsjkdh) -->
                        <!-- <p class="text-gray-400" *ngIf="game.layers">
                            {{ 'game.' + game.transKey + '.layers' | translate }}
                        </p> -->

                    </div>

                </div>

                <div class="
                    space-y-2
                    p-4

                    bg-zinc-900

                    shadow-md shadow-black/30
                    rounded-xl
                    border border-zinc-800
                    ">

                    <h3 class="
                        font-semibold text-gray-50
                        bg-pink-500/0
                        ">
                        {{ 'pages.games.Visualization' | translate}}
                    </h3>

                    <div class="
                        flex flex-row
                        gap-2 md:gap-6

                        py-4
                        h-[50vw] lg:h-[20vw]

                        bg-orange-500/0
                        overflow-x-auto
                        ">

                        <ng-container *ngIf="
                            (!game.GenericMediasList || game.GenericMediasList.length <= 0)
                            &&
                            (!game.images || game.images.length <= 0)
                            &&
                            (!game.video || game.video.length <= 0)
                            ">

                            <div class="
                                    flex gap-1
                                    items-center justify-center

                                    aspect-square
                                    h-full

                                    rounded-lg
                                    bg-zinc-800
                                    text-gray-300

                                    leading-[1.2rem]
                                    ">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="
                                        w-5 h-5
                                        text-gray-400
                                        ">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.75 4.5h16.5v15H3.75v-15zM3.75 15l3.75-3.75 2.25 2.25 3-3L20.25 15" />
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M9.75 9.75h.008v.008H9.75V9.75z" />
                                </svg>

                                <span class="max-w-[70%]">
                                    {{ 'pages.errors.Media not yet available...' | translate }}
                                </span>

                            </div>
                        </ng-container>

                        <ng-container *ngIf="game.GenericMediasList && game.GenericMediasList.length > 0">

                            <ng-container *ngFor="let media of game.GenericMediasList">

                                <ng-container *ngIf="media.Type == 'image'">

                                    <div class="
                                        relative

                                        h-full min-w-max
                                        bg-green-500/0
                                        ">

                                        <img *ngIf="!_mediasWithLoadingErrorsList.includes(media)"
                                            [src]="media.SourceUrl" class="h-full w-auto rounded-lg bg-zinc-800"
                                            (error)="onImageError($event, media)" alt="Game image">


                                        <div *ngIf="_mediasWithLoadingErrorsList.includes(media)"
                                            class="flex h-[220px] w-full items-center justify-center rounded-lg bg-zinc-800 text-gray-300">
                                            <p class="text-red-400/60 italic">
                                                {{ 'pages.errors.~Error trying to load image :(' | translate }}
                                            </p>
                                        </div>

                                        <div *ngIf="media.Sumarry" class="
                                            absolute
                                            flex flex-col
                                            align-middle items-center text-center justify-center

                                            bottom-0 right-0 left-0
                                            p-1.5 sm:p-3

                                            italic

                                            bg-black/75
                                            rounded-b-lg

                                            text-xs sm:text-base
                                            leading-[1.2rem]
                                            ">

                                            <!-- @if (media.Id)
                                            {
                                            <span>
                                                {{
                                                (
                                                'game.' +
                                                game.transKey +
                                                '.GenericMedias.' +
                                                media.Id
                                                ) | translate
                                                }}
                                            </span>
                                            }
                                            @else
                                            {
                                            <span>{{ media.Sumarry }} </span>
                                            } -->

                                        </div>

                                    </div>

                                </ng-container>

                                <ng-container *ngIf="media.Type == 'video'">

                                    <div class="
                                        relative

                                        aspect-video
                                        h-full
                                        ">

                                        <video *ngIf="media.SourceUrl && !_mediasWithLoadingErrorsList.includes(media)"
                                            [src]="media.SourceUrl" [muted]="true" muted [autoplay]="true" autoplay
                                            playsinline [loop]="true" class="
                                            rounded-lg bg-black
                                            " (error)="onVideoError($event, media)">
                                        </video>

                                        <div *ngIf="_mediasWithLoadingErrorsList.includes(media)" class="
                                            flex gap-1
                                            items-center justify-center

                                            h-full w-full

                                            bg-zinc-800
                                            rounded-lg

                                            text-red-400/60 italic
                                            leading-[1.2rem]
                                            ">

                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M15.75 12.0l-6 3.75v-7.5l6 3.75z" />
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>

                                            <p>
                                                {{ 'pages.errors.~Error trying to load demo video :(' | translate }}
                                            </p>

                                        </div>

                                        <div *ngIf="media.Sumarry" class="
                                            absolute
                                            flex flex-col
                                            align-middle items-center text-center justify-center

                                            bottom-0 right-0 left-0
                                            p-1.5 sm:p-3

                                            italic

                                            bg-black/75
                                            rounded-b-lg

                                            text-xs sm:text-base
                                            leading-[1.2rem]
                                            ">

                                            <!-- <span> {{ media.Sumarry }} </span> -->

                                            @if (media.Id)
                                            {
                                            <span>
                                                {{
                                                (
                                                'game.' +
                                                game.transKey +
                                                '.GenericMedias.' +
                                                media.Id
                                                ) | translate
                                                }}
                                            </span>
                                            }
                                            @else
                                            {
                                            <span>{{ media.Sumarry }} </span>
                                            }

                                        </div>
                                    </div>


                                </ng-container>

                            </ng-container>

                        </ng-container>

                        <!-- TODO: REVIEW THIS! (old media support) -->
                        <ng-container *ngIf="!game.GenericMediasList || game.GenericMediasList.length <= 0">

                            <div class="
                                relative

                                aspect-video
                                h-full
                                ">
                                <video *ngIf="game.video && !_errorsVideoPaths.includes(game.video)" [src]="game.video"
                                    [muted]="true" muted [autoplay]="true" autoplay playsinline [loop]="true" class="
                                    rounded-lg bg-black
                                    " (error)="onVideoError($event)">
                                </video>

                            </div>

                            <div *ngIf="_errorsVideoPaths.includes(game.video)" class="
                                flex gap-2
                                items-center justify-center

                                h-[220px] w-full

                                bg-zinc-800
                                rounded-lg

                                text-red-400/60 italic
                                ">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15.75 12.0l-6 3.75v-7.5l6 3.75z" />
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>

                                <p> ~Error trying to load demo video :( </p>

                            </div>

                            <!-- <div class="md:w-1/2 space-y-2">

                                <div *ngIf="!game.video" class="
                                    flex gap-2
                                    items-center justify-center

                                    aspect-video
                                    h-full w-auto

                                    bg-zinc-800
                                    rounded-lg

                                    text-gray-300
                                    ">

                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M15.75 12.0l-6 3.75v-7.5l6 3.75z" />
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>

                                    <p> Demo Video not yet available... </p>

                                </div>

                            </div> -->

                            <ng-container *ngFor="let img of game.images">
                                <img *ngIf="!_errorsImagePaths.includes(img)" [src]="img" class="
                                        h-full w-auto
                                        object-cover rounded-lg bg-zinc-800" (error)="onImageError($event)"
                                    alt="Game image">

                                <div *ngIf="_errorsImagePaths.includes(img)"
                                    class="flex h-[220px] w-full items-center justify-center rounded-lg bg-zinc-800 text-gray-300">
                                    <p class="text-red-400/60 italic">
                                        ~Error trying to load image :(
                                    </p>
                                </div>
                            </ng-container>
                        </ng-container>

                    </div>

                </div>

                <div class="
                    space-y-4
                    p-4

                    text-gray-400
                    ">

                    <h3 class="
                        font-semibold text-gray-50
                        bg-pink-500/0
                        ">
                        {{ 'pages.games.Description' | translate}}
                    </h3>



                    @if (game.GenericDescriptionContentList && game.GenericDescriptionContentList.length > 0)
                    {
                    <ng-container *ngFor="let descriptionContent of game.GenericDescriptionContentList">



                        <ng-container *ngIf="descriptionContent.Type == 'paragraph'">
                            @if(descriptionContent.Id)
                            {
                            <p>
                                {{
                                (
                                'game.' +
                                game.transKey +
                                '.GenericDescriptionContent.' +
                                descriptionContent.Id
                                ) | translate
                                }}
                            </p>
                            }
                            @else
                            {
                            <p>
                                {{ descriptionContent.TextContent }}
                            </p>
                            }
                        </ng-container>


                        <div *ngIf="descriptionContent.Type == 'list'" class="
                            space-y-1
                            pl-6 sm:pl-10
                            ">

                            <ng-container
                                *ngFor="let textContent of descriptionContent.TextContentList as LocalizableTextListItem">

                                @if (textContent.Id)
                                {
                                <li>
                                    {{
                                    (
                                    'game.' +
                                    game.transKey +
                                    '.GenericDescriptionContent.' +
                                    textContent.Id
                                    ) | translate
                                    }}
                                </li>
                                }
                                @else
                                {
                                <li>
                                    {{ textContent}}
                                </li>
                                }

                            </ng-container>

                        </div>

                    </ng-container>
                    }
                    @else
                    {
                    <p class="italic">
                        ~Not available yet... :l
                    </p>
                    }

                </div>

            </div>

            <div class="bg-cyan-500/0 w-full overflow-x-hidden lg:col-span-3">

                <div *ngIf="game.balancing && game.balancing.length" class="
                    p-4
                    mx-auto
                    w-max max-w-full

                    bg-zinc-900
                    border-zinc-800
                    rounded-xl border
                    shadow-md shadow-black/30

                    overflow-x-hidden
                    ">

                    <h3 class="mb-3 text-lg font-semibold text-gray-50 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 h-5 text-gray-400">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M3 13.5h2.25V21H3v-7.5zm5.25-4.5h2.25V21H8.25V9zm5.25-6h2.25V21h-2.25V3zm5.25 9h2.25v9h-2.25v-9z" />
                        </svg>
                        {{ 'pages.games.balancing' | translate }}
                    </h3>

                    <div class="overflow-x-auto">
                        <table class="border-collapse text-sm text-gray-100">

                            <thead>
                                <tr>
                                    <th class="border border-zinc-800 px-2 py-2 bg-zinc-900"></th>
                                    <th class="border border-zinc-800 px-2 py-2 bg-zinc-800 text-gray-100"
                                        *ngFor="let diff of difficulties">{{ 'difficulty.' + diff | translate }}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let param of game.balancing" (mouseleave)="clearDiffHighlight()"
                                    class="odd:bg-zinc-800/30">
                                    <td class="border border-zinc-800 px-2 py-2 text-left font-semibold text-gray-100"
                                        [title]="'paramDesc.' + param.key | translate">
                                        {{ 'paramName.' + param.key | translate }}
                                    </td>
                                    <td class="border border-zinc-800 px-2 py-2 text-center"
                                        *ngFor="let diff of difficulties"
                                        (mouseenter)="highlightDifferences(param, diff)">
                                        {{ param.values[diff] }}

                                        @if (currentParamKey === param.key && differences)
                                        {
                                        <span class="block text-xs mt-1" [ngClass]="{
                                                    'text-green-400': differences[diff] && differences[diff].startsWith('+'),
                                                    'text-red-400': differences[diff] && differences[diff].startsWith('-') && differences[diff] !== '--',
                                                    'text-gray-400': differences[diff] === '--'
                                                }">
                                            {{ differences[diff] }}
                                        </span>
                                        }
                                        @else
                                        {
                                        <span class="block text-xs mt-1 text-gray-400">
                                            --
                                        </span>
                                        }

                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>

                </div>

                <div *ngIf="chart" class="
                    p-4
                    bg-zinc-900
                    rounded-xl border border-zinc-800
                    shadow-md shadow-black/30
                    ">

                    <h3 class="mb-3 text-lg font-semibold text-gray-50 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 h-5 text-gray-400">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6l3 3" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
                        </svg>
                        Round Duration
                    </h3>

                    <div class="max-w-[600px] mx-auto">
                        <canvas #rdChart class="mx-auto block border border-zinc-800 bg-zinc-950 rounded"></canvas>
                    </div>
                </div>

                <div class="rounded-xl border border-zinc-800 bg-zinc-900 p-4 shadow-md shadow-black/30"
                    *ngIf="game.levels && game.levels.length">
                    <h3 class="mb-3 text-lg font-semibold text-gray-50 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 h-5 text-gray-400">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9 9l6 6m0-6l-6 6M4.5 6.75h15m-15 10.5h15" />
                        </svg>
                        Progression
                    </h3>
                    <p class="text-gray-300 italic mb-2">*(This game does not use difficulty levels; progression is
                        shown below.)*</p>
                    <div class="overflow-x-auto">
                        <table class="w-full border-collapse text-sm text-gray-100">
                            <thead>
                                <tr>
                                    <th class="border border-zinc-800 px-2 py-2">Level</th>
                                    <th class="border border-zinc-800 px-2 py-2">Pixels range</th>
                                    <th class="border border-zinc-800 px-2 py-2">Draw size</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let lvl of game.levels" class="odd:bg-zinc-900/60">
                                    <td class="border border-zinc-800 px-2 py-2 text-center">{{ lvl.level }}</td>
                                    <td class="border border-zinc-800 px-2 py-2 text-center">{{ lvl.pixels }}</td>
                                    <td class="border border-zinc-800 px-2 py-2 text-center">{{ lvl.draw }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="rounded-xl border border-zinc-800 bg-zinc-900 p-4 shadow-md shadow-black/30"
                    *ngIf="game.note">
                    <h3 class="mb-2 text-lg font-semibold text-gray-50 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 h-5 text-gray-400">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.545 2.177a.75.75 0 001.063.853l.04-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                        </svg>
                        Note
                    </h3>
                    <p class="text-gray-300">{{ game.note }}</p>
                </div>
            </div>
        </section>
    </ng-container>
</div>